import ThemeFeature from "./themeFeature";

class StickyNavbar extends ThemeFeature {
    /**
     * Sticky navbar
     * @param {string} selector
     * @param {number} [scrollOffset=170]
     */
    enable(selector = '.navbar-sticky', scrollOffset = 170) {
        const element = document.querySelector(selector);

        if (element === null) {
            return;
        }

        const elementHeight = element.getBoundingClientRect().height;

        document.addEventListener('scroll', () => {
            if (window.scrollY > scrollOffset) {
                if (!element.classList.contains('navbar-stuck')) {
                    element.classList.add('navbar-stuck');
                    document.body.style.paddingTop = elementHeight + 'px';
                }
            } else {
                if (element.classList.contains('navbar-stuck')) {
                    element.classList.remove('navbar-stuck');
                    document.body.style.paddingTop = '0px';
                }
            }
        });
    }
}

export default StickyNavbar;
